import { withInstall } from "../utils/index.mjs";
import _Icon from "./Icon.mjs";
const Icon = withInstall(_Icon);
var stdin_default = Icon;
import { iconProps } from "./Icon.mjs";
export {
  Icon,
  stdin_default as default,
  iconProps
};
